module.exports = __webpack_public_path__ + "static/chunks/algorithm.d244dc5c59c6c6ee3938.worker.js"